import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Tabs, { TabHeader, TabPanels } from 'components/Tabs';
import { useFetchADPSettings } from 'hooks/integrations/useFetchADPSettings';

import CodesMapping from './CodesMapping';
import CostCodesMapping from './CostCodesMapping';
import WorkersMapping from './WorkersMapping';

const MappingTabs = () => {
  const { t } = useTranslation(['integrations']);

  const initialTabHeaders = [
    { label: t('integrations:adp.workers') },
    { label: t('integrations:adp.codes') },
    { label: t('integrations:adp.costCodes') },
  ];

  const [tabHeaders, setTabHeaders] = useState(initialTabHeaders);

  const { data } = useFetchADPSettings();

  const tabPanels = [
    { panel: <WorkersMapping /> },
    { panel: <CodesMapping /> },
    { panel: <CostCodesMapping showDepartmentCodes={data?.payload?.use_job_code} /> },
  ];

  useEffect(() => {
    const showCostCodes = data?.payload?.enable_cost_code;
    const useDepartmentCodes = data?.payload?.use_job_code;

    if (!showCostCodes) {
      const tabHeaders = initialTabHeaders.filter(header => header.label !== t('integrations:adp.costCodes'));
      setTabHeaders(tabHeaders);
    } else if (useDepartmentCodes) {
      const tabHeaders = initialTabHeaders.map(header => {
        if (header.label === t('integrations:adp.costCodes')) {
          return { label: t('integrations:adp.departmentCodes') };
        }

        return header;
      });

      setTabHeaders(tabHeaders);
    } else {
      setTabHeaders(initialTabHeaders);
    }
  }, [data]);

  return (
    <Tabs>
      <TabHeader tabHeaders={tabHeaders} />
      <TabPanels tabPanels={tabPanels} />
    </Tabs>
  );
};
export default MappingTabs;
